// extracted by mini-css-extract-plugin
export default {"wrap":"zq-z","fullWidth":"Aq-z","items":"Bq-z","featureCss":"Cq-z","disabled":"Dq-z","imgCss":"Eq-z"};